<template>
  <v-container
    id="riparazioni"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-eye-refresh"
      class="px-5 py-3"
      width="100%"
    >
      <v-row>
        <v-col
          cols="12"
        >
          <table
            v-if="cliente"
            class="text-h3 text-weigth-light"
          >
            <tr>
              <td class="text-no-wrap pr-3">
                Cliente
                <div v-if="isMobile">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </div>
              </td>
              <td v-if="!isMobile">
                {{ cliente.ragsoc }} {{ cliente.indiri_1 }}
              </td>
            </tr>
            <tr v-if="!isMobile">
              <td /><td>{{ cliente.indiri2 }} {{ cliente.locali }} </td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
        >
          <template>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="onSubmit()"
            >
              <v-text-field
                v-model="lens.desrif"
                :rules="rifRules"
                label="Riferimento Occhiale"
                hint="Dato obbligatorio per la validità della garanzia"
                persistent-hint
                required
              />
              <v-radio-group
                v-model="lens.lendor"
                column
              >
                <v-radio
                  label="Lenti  da me ordinate"
                  value="CC"
                />
                <v-radio
                  label="Lenti da ordinare per ns. conto"
                  value="CD"
                />
              </v-radio-group>

              <v-text-field
                v-model="lens.altra_ditta_lenti"
                label="Ditta Lenti"
              />
              <v-menu
                v-model="menu_data_lenti"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="lens.dataord_lenti"
                    label="Data ordine lenti"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="lens.dataord_lenti"
                  @input="menu_data_lenti = false"
                />
              </v-menu>
              <v-text-field
                v-model="lens.identi"
                label="Cod. Ditta Lenti"
              />
              <span class="text-h2 text-weigth-light mt8">Caratteristiche Lenti ed occhiale</span>
              <v-row class="mt-1">
                <v-col
                  class="bordered text-center text-h2 text-no-wrap"
                  cols="12"
                  md="2"
                >
                  <!-- <v-btn
                    color="primary"
                    x-small
                    class="
                    float-left"
                  >
                    <v-icon
                      x-small
                      v-text="'mdi-square-edit-outline'"
                    />
                  </v-btn> -->

                  <div class="">
                    OD
                  </div>
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_vsfero"
                    type="number"
                    outlined
                    label="SF"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_cilind"
                    type="number"
                    outlined
                    label="CYL"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_vlasse"
                    type="number"
                    outlined
                    label="ASSE"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_addizi"
                    type="number"
                    outlined
                    label="ADD."
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_destip"
                    outlined
                    label="TIPO E MARCA"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  class="bordered text-center text-h2 text-no-wrap"
                  cols="12"
                  md="2"
                >
                  <!-- <v-btn
                    color="primary"
                    x-small
                    class="
                    float-left"
                  >
                    <v-icon
                      x-small
                      v-text="'mdi-square-edit-outline'"
                    />
                  </v-btn> -->

                  <div class="">
                    OS
                  </div>
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.s_vsfero"
                    type="number"
                    outlined
                    label="SF"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.s_cilind"
                    type="number"
                    outlined
                    label="CYL"
                  />
                </v-col>
                <v-col
                  class="bordered text-center"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.s_vlasse"
                    type="number"
                    outlined
                    label="ASSE"
                  />
                  <v-radio-group
                    v-model="lens.tabint"
                    class="ma-0"
                    row
                  >
                    <v-radio
                      label="TABO"
                      value="TABO"
                    />
                    <v-radio
                      label="INT"
                      value="INT"
                    />
                  </v-radio-group>
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_addizi"
                    type="number"
                    outlined
                    label="ADD."
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.s_destip"
                    outlined
                    label="TIPO E MARCA"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  class="bordered  text-no-wrap"
                  cols="12"
                  md="2"
                >
                  <!-- <v-btn
                    color="primary"
                    x-small
                    class="
                    float-left"
                  >
                    <v-icon
                      x-small
                      v-text="'mdi-square-edit-outline'"
                    />
                  </v-btn> -->

                  <v-text-field
                    v-model="lens.distan"
                    type="number"
                    outlined
                    label="DI"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_semidi"
                    type="number"
                    outlined
                    label="POD"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.s_semidi"
                    type="number"
                    outlined
                    label="POS"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.d_altezz"
                    type="number"
                    outlined
                    label="HOD"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.s_altezz"
                    type="number"
                    outlined
                    label="HOS"
                  />
                </v-col>
                <v-col
                  class="bordered"
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="lens.destrt"
                    outlined
                    label="TRATTAMENTI"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="bordered  text-no-wrap"
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="lens.desmod"
                    label="Cod. modello"
                  />
                </v-col>
                <v-col
                  class="bordered  text-no-wrap"
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="lens.calibr"
                    label="Calibro"
                    type="number"
                    min="0"
                  />
                </v-col>
              </v-row>
              <div class="text-h2 text-weigth-light mt-8">
                Lavorazioni da eseguire
              </div>
              <v-row class="mt-2">
                <v-textarea
                  v-model="lens.deslav"
                  outlined
                  label="Istruzioni"
                />
              </v-row>
              <v-switch

                v-model="order.pt_usati"
                :disabled="puntidisponibili< config.puntiSblocco"
                color="success"
                hide-details
              >
                <template v-slot:label>
                  <span v-if="puntidisponibili< config.puntiSblocco">
                    Sbloccco utilizzo punti non superato
                  </span>
                  <span
                    v-else
                    class="text-h3"
                    :style="(order.pt_usati??0)>0?'color:#F00':'color:#ccc'"
                  > *Utilizzo {{ config.puntiCostoRiparazione }} punti</span>
                </template>
              </v-switch>
              <v-divider
                class="ma-8"
                dark
              />

              <!-- <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
              />

              <v-select
                v-model="select"
                :items="items"
                :rules="[v => !!v || 'Item is required']"
                label="Item"
                required
              />

              <v-checkbox
                v-model="checkbox"
                :rules="[v => !!v || 'You must agree to continue!']"
                label="Do you agree?"
                required
              /> -->

              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="validate"
              >
                Validate
              </v-btn>

              <v-btn
                color="error"
                class="mr-4"
                @click="reset"
              >
                Reset Form
              </v-btn>

              <v-btn
                color="warning"
                @click="resetValidation"
              >
                Reset Validation
              </v-btn>
              <v-btn
                class="mr-4"
                type="submit"
                :disabled="!valid"
              >
                submit
              </v-btn>
            </v-form>
          </template>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Riparazioni',
    components: {

    },
    data () {
      return {
        loading: false,
        cliente: null,
        valid: true,
        order: {},
        lens: {},

        puntidisponibili: 0,

        desrif: '',
        rifRules: [
          v => !!v || 'Riferiemento è obbligatorio',
          // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],

        menu_data_lenti: false,
        dataord_lenti: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

        // email: '',
        // emailRules: [
        //   v => !!v || 'E-mail is required',
        //   v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        // ],
        // select: null,
        // items: [
        //   'Item 1',
        //   'Item 2',
        //   'Item 3',
        //   'Item 4',
        // ],
        // checkbox: false,

      }
    },
    computed: {
      ...mapState(['auth']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      config () {
        return Config
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      var codcli = `${codsog}${coddes}`
      console.log('analisi codcli', codcli)
      this.get_puntiDisponibili(codcli)
      this.get_anagrafica(codcli)
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_anagrafica (codcli) {
        this.loading = true
        engine.get_anagrafica(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.cliente = result.data
            this.get_puntiDisponibili(codcli)
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      get_puntiDisponibili (codcli) {
        this.loading = true
        engine.get_puntiDisponibili(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.puntidisponibili = parseInt(result.data.totpunti) || 0
            this.loading = false
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onSubmit () {
        this.valid = this.$refs.form.validate()
        if (this.valid) {
          console.log('send', this.lens)
          const data = { lens: this.lens, cliente: this.cliente }
          engine.sendRiparazione(data).then((result) => {
            if (result) {
              // alert('Form has been submitted!')
              console.log('sendRiparazione', result)
              this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
            }
          })
            .catch((errore) => {
              // eslint-disable-next-line no-console
              console.error('ERR####', errore)
            })
          return
        }
        this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
        this.$vuetify.goTo(0) // scroll top
        console.log('send invadlid', this.lens)

        // engine.sendOrder(this.lens, this.page).then((result) => {
        //   if (result) {
        //     // alert('Form has been submitted!')
        //     console.log('update newitem', result)
        //     this.$emit('updateItem', result)
        //     this.$emit('close')
        //   }
        // })
        //   .catch((errore) => {
        //     // eslint-disable-next-line no-console
        //     console.error('ERR####', errore)
        //     this.$store.commit('setSnack', { message: 'General Error', color: '#c54747d4' })
        //   })
      },
    },
  }

</script>
<style>
#riparazioni .bordered{
  border:1px solid #ccc;

}
</style>
